import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
	name: 'DNI'
})
export class DniPipe implements PipeTransform {
	//valur: Valor a procesar.
	//separador: caracter con el cual se va a separar el número.
	//cantidadDigitos: cada cuantos dígitos hay que poner el separador.
	transform(value: number, separador: string = ".", cantidadDigitos: number = 3): string {
		if (!value) {
			return "";
		}

		let Resultado: string = "";
		let Valor: string = value.toString();
		let Largo: number = value.toString().length;

		//Si la cantidad de dígitos es mayor a la longitud, devuelvo el valor ya que no le va ningún separador.
		if (cantidadDigitos > Largo) {
			return value.toString();
		}

		let Resto: number = Largo % cantidadDigitos;

		//Si el resto de la división es mayor a 0, recorto el primer pedactio.
		if (Resto > 0) {
			Resultado = Valor.substring(0, Resto) + separador;
		}

		//Calculo los bloques restantes
		let CantidadBloques: number = parseInt((Largo / cantidadDigitos).toString());

		for (var i = 0; i < CantidadBloques; i++) {
			let Inicio = (i * cantidadDigitos) + Resto;
			let Fin = Inicio + cantidadDigitos;

			Resultado += Valor.substring(Inicio, Fin);

			if (i + 1 < CantidadBloques) {
				Resultado += separador;
			}
		}

		return Resultado;
	}
}